import React, { useState, useEffect } from "react";
import "./FbBooknow.css";
import { accordionItems, plans, fbServices } from "./fbData.js";
import FBSlider from "../fb_LandingPage/fbSlider.jsx";
import Testimonial from "../../components/Testimonial/testimonial";
import FBpandit from "../../assets/image/fbposterpandit.png";
import FBAmitabh from "../../assets/image/Amitabh Bachchan.jpg";
import FBSalman from "../../assets/image/Salman Khan.jpg";
import FBEkta from "../../assets/image/ekta-kapoor.jpg";
import FbShilpa from "../../assets/image/shilpa.jpg";
import FBNita from "../../assets/image/nita.png";
import FBSanjay from "../../assets/image/sanjay dutt.jpg";

function FbBooknow() {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [popupType, setPopupType] = useState("success");
  const [successMessage, setSuccessMessage] = useState("");
  const [whatsappMessage, setWhatsappMessage] = useState("");

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    dob: "",
    birthTime: "",
    birthCity: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFixedPlanPayClick = () => {
    setSelectedPlan({
      label: "Fixed Gemstone Plan",
      value: 111,
      name: "Know your correct gemstone now",
      features: [
        "Gemstone recommendation based on birth chart",
        "Simple remedy guidance",
      ],
    });

    setErrors({});
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setErrors({});
    setIsSubmitting(false);
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "phone") {
      updatedValue = value.replace(/\D/g, "").slice(0, 10);
    }

    setForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    if (!form.name.trim()) newErrors.name = "Name is required";

    if (!form.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) {
      newErrors.email = "Enter a valid email address";
    }

    const cleanPhone = String(form.phone).replace(/\D/g, "");

    if (!cleanPhone) {
      newErrors.phone = "Phone number is required";
    } else if (!/^[6-9]\d{9}$/.test(cleanPhone)) {
      newErrors.phone = "Enter a valid Indian mobile number";
    }

    if (!form.dob) newErrors.dob = "Date of birth is required";
    if (!form.birthTime) newErrors.birthTime = "Birth time is required";
    if (!form.birthCity.trim())
      newErrors.birthCity = "Place of birth is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const getPlanAmount = (plan) => {
    if (!plan) return 0;

    if (typeof plan.value === "number") return plan.value;

    if (typeof plan.value === "string") {
      const cleaned = plan.value.replace(/[^\d.]/g, "");
      return Number(cleaned || 0);
    }

    return 0;
  };

  const handleEmailAndPay = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (!selectedPlan) {
      alert("Please select a plan");
      return;
    }

    const amount = getPlanAmount(selectedPlan);

    if (!amount || amount <= 0) {
      alert("Invalid plan amount");
      return;
    }

    setIsSubmitting(true);

    try {
      const whatsappText = `Namaskar 🙏

I have successfully completed the payment for "${selectedPlan?.name || "Gemstone Consultation"}".

Plan: ${selectedPlan?.label || ""}
Amount: ₹${amount}

Name: ${form.name}
Phone: ${form.phone}
Email: ${form.email}
DOB: ${form.dob}
Birth Time: ${form.birthTime}
Place of Birth: ${form.birthCity}

Please guide me with my correct gemstone recommendation.`;

      localStorage.setItem("gemstone_whatsapp_message", whatsappText);

      const payload = {
        amount,
        plan_id: "fbbooknow",
        payment_type: "fbbooknow",
        name: form.name.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        dob: form.dob,
        birthTime: form.birthTime,
        birthCity: form.birthCity,
        item_name: selectedPlan?.name || "Gemstone Consultation",
        item_type: "gemstone_consultation",
        plan_name:
          selectedPlan?.label || selectedPlan?.name || "Gemstone Consultation",
        plan_value: amount,
      };

      const res = await fetch(
        "https://dashboard.jyotirvani.com/api/generate-token",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const text = await res.text();
      console.log("RAW PAYMENT RESPONSE:", text);

      let data;

      try {
        data = JSON.parse(text);
      } catch (error) {
        console.error("Invalid JSON:", text);
        alert("Backend JSON return korche na");
        setIsSubmitting(false);
        return;
      }

      console.log("PAYMENT RESPONSE:", data);

      if (!res.ok || !data.status) {
        alert(data?.message || "Payment request failed");
        setIsSubmitting(false);
        return;
      }

      if (!window.Razorpay) {
        alert("Razorpay SDK load hoyni. index.html e script add koro.");
        setIsSubmitting(false);
        return;
      }

      const options = {
        key: data.key,
        amount: data.amount,
        currency: data.currency || "INR",
        name: "JyotirVani",
        description: selectedPlan?.name || "Gemstone Consultation",
        order_id: data.order_id,

        handler: async function (response) {
          try {
            const verifyRes = await fetch(
              "https://dashboard.jyotirvani.com/api/verify-razorpay-payment",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  razorpay_order_id: response.razorpay_order_id,
                  razorpay_payment_id: response.razorpay_payment_id,
                  razorpay_signature: response.razorpay_signature,
                  local_order_id: data.local_order_id,
                  return_type: "fbbooknow",
                }),
              },
            );

            const verifyData = await verifyRes.json();
            console.log("VERIFY RESPONSE:", verifyData);

            if (verifyData.status) {
              const user = JSON.parse(localStorage.getItem("user") || "null");

              const historyKey = user?.email
                ? `payment_history_${user.email}`
                : "payment_history_guest";

              const oldHistory =
                JSON.parse(localStorage.getItem(historyKey)) || [];

              const newHistory = {
                order_id: data.local_order_id,
                type: "plan",
                title: selectedPlan?.name || "Gemstone Consultation",
                amount: amount,
                payment_status: "success",
                payment_mode: "Razorpay",
                date: new Date().toISOString(),
              };

              localStorage.setItem(
                historyKey,
                JSON.stringify([newHistory, ...oldHistory]),
              );

              setShowModal(false);
              setPopupType("success");
              setSuccessMessage(
                `Payment Successful! Your booking has been confirmed. Order ID: ${
                  data.local_order_id || ""
                }`,
              );
              setWhatsappMessage(whatsappText);
              setShowSuccessPopup(true);
              setIsSubmitting(false);
            } else {
              alert(verifyData.message || "Payment verification failed");
              setIsSubmitting(false);
            }
          } catch (err) {
            console.error("VERIFY ERROR:", err);
            alert("Payment verification failed");
            setIsSubmitting(false);
          }
        },

        prefill: {
          name: form.name.trim(),
          email: form.email.trim(),
          contact: form.phone.trim(),
        },

        notes: {
          local_order_id: data.local_order_id,
          plan_name: selectedPlan?.label || "",
          item_type: "gemstone_consultation",
        },

        theme: {
          color: "#7c3aed",
        },

        modal: {
          ondismiss: function () {
            setIsSubmitting(false);
          },
        },
      };

      const razorpay = new window.Razorpay(options);
      razorpay.open();
    } catch (err) {
      console.error("PAY ERROR:", err);
      alert(err?.message || "Failed to continue. Please try again.");
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const paymentStatus =
      params.get("payment") ||
      params.get("status") ||
      params.get("payment_status");

    const orderId = params.get("order_id");
    const storedMessage = localStorage.getItem("gemstone_whatsapp_message");

    if (paymentStatus === "success" || paymentStatus === "paid") {
      setPopupType("success");
      setSuccessMessage(
        `Payment Successful! Your booking has been confirmed. Order ID: ${
          orderId || ""
        }`,
      );

      if (storedMessage) {
        setWhatsappMessage(storedMessage);
      }

      setShowSuccessPopup(true);

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }, 1200);
    }

    if (paymentStatus === "failed") {
      setPopupType("failed");
      setSuccessMessage("Payment Failed! Please try again.");
      setShowSuccessPopup(true);

      setTimeout(() => {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname,
        );
      }, 1200);
    }
  }, []);

  return (
    <div>
      {showSuccessPopup && (
        <div className="FB-qr-modal-overlay">
          <div className="FB-qr-modal-content" style={{ textAlign: "center" }}>
            <div
              style={{
                width: "74px",
                height: "74px",
                margin: "0 auto 16px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "40px",
                fontWeight: "900",
                background: popupType === "success" ? "#dcfce7" : "#fee2e2",
                color: popupType === "success" ? "#16a34a" : "#dc2626",
              }}
            >
              {popupType === "success" ? "✓" : "!"}
            </div>

            <h2 style={{ color: popupType === "success" ? "green" : "red" }}>
              {popupType === "success"
                ? "Payment Successful 🎉"
                : "Payment Failed"}
            </h2>

            <p>{successMessage}</p>

            <button
              className="ra-plan-contact-btn"
              onClick={() => {
                if (popupType === "success" && whatsappMessage) {
                  window.open(
                    `https://wa.me/919616339090?text=${encodeURIComponent(
                      whatsappMessage,
                    )}`,
                    "_blank",
                    "noopener,noreferrer",
                  );
                }

                setShowSuccessPopup(false);
                localStorage.removeItem("gemstone_whatsapp_message");
              }}
            >
              {popupType === "success" ? "Continue WhatsApp" : "OK"}
            </button>
          </div>
        </div>
      )}

      <div className="gem-page">
        <section className="gem-hero-section">
          <div className="container">
            <div className="gem-top-text">
              {/* <span className="gem-badge">Gemstone Guidance</span> */}

              <h2>Aapke dwara dharan kiya gaya ek sahi gemstone</h2>

              <ul>
                <li>
                  Aapki life me positive energy aur stability la sakta hai.
                </li>
                <li>
                  Health, confidence aur mental peace ko behtar banane me
                  sahayak ho sakta hai.
                </li>
                <li>
                  Financial growth aur career opportunities ko majboot kar sakta
                  hai.
                </li>
                <li>
                  Negative energies aur grahon ke pratikool prabhav ko kam karne
                  me madad kar sakta hai.
                </li>
                <li>
                  Bhagya, safalta aur jeevan ki stability ko strong bana sakta
                  hai.
                </li>
                <li>
                  Immunity aur wellness ko support karke lambi umra me sahayak
                  ho sakta hai.
                </li>
              </ul>

              <p className="gem-connect-text">
                Humare Pandit Ji se connect karke sahi gemstone guidance prapt
                karein.
              </p>
            </div>

            <div className="gem-hero-card">
              <div className="gem-hero-text">
                <p>
                  Talk to an Expert <span>🔴 Live</span> &
                </p>
                <h1>Discover Your Lucky Gemstone!</h1>
                <h3>In Just 15 Mins.</h3>
              </div>

              <img src={FBpandit} alt="Pandit Ji" />
            </div>

            <div className="gem-stats">
              <div>
                <span>☺</span>
                <h3>4987+</h3>
                <p>Consultations</p>
              </div>

              <div>
                <span>☆</span>
                <h3>4.8/5</h3>
                <p>Average rating</p>
              </div>

              <div>
                <span>◎</span>
                <h3>100%</h3>
                <p>
                  Accurate
                  <br />
                  Predictions
                </p>
              </div>
            </div>

            <p className="gem-call-text">
              Talk to our celebrity astrologers by booking consultation call
              right now.
            </p>

            <button
              type="button"
              className="gem-main-btn"
              onClick={handleFixedPlanPayClick}
            >
              🔮 Know your correct gemstone now @ Rs.111/- Only
            </button>
          </div>
        </section>

        <section className="gem-celebrity-section">
          <div className="container">
            <h2 className="gem-big-title">
              Ek sahi Rashi Ratna aapki <br />
              zindagi badal sakta hai!
            </h2>

            <div className="celebrity-grid">
              <div className="celebrity-card">
                <img src={FBAmitabh} alt="Amitabh Bachchan" />
                <div>
                  <h4>Amitabh Bachchan</h4>
                  <p>Blue Sapphire GemStone</p>
                </div>
              </div>

              <div className="celebrity-card">
                <img src={FBSalman} alt="Salman Khan" />
                <div>
                  <h4>Salman Khan</h4>
                  <p>Firoza Gemstone</p>
                </div>
              </div>

              <div className="celebrity-card">
                <img src={FBEkta} alt="Ekta Kapoor" />
                <div>
                  <h4>Ekta Kapoor</h4>
                  <p>Many Gemstone</p>
                </div>
              </div>

              <div className="celebrity-card">
                <img src={FbShilpa} alt="Shilpa Shetty" />
                <div>
                  <h4>Shilpa Shetty</h4>
                  <p>Pukhraj Yellow Sapphire Emerald GemStone</p>
                </div>
              </div>

              <div className="celebrity-card">
                <img src={FBSanjay} alt="Sanjay Dutt" />
                <div>
                  <h4>Sanjay Dutt</h4>
                  <p>Yellow Sapphire & Natural Pearl Gemstone</p>
                </div>
              </div>

              <div className="celebrity-card">
                <img src={FBNita} alt="Nita Ambani" />
                <div>
                  <h4>Nita Ambani</h4>
                  <p>Emerald Gemstones</p>
                </div>
              </div>
            </div>

            <div className="gem-white-cta">
              <h3>
                Agar apko inmese kisi bhi chez ko hasil karna hai toh book
                consultation call now
              </h3>

              <button
                type="button"
                className="gem-small-btn"
                onClick={handleFixedPlanPayClick}
              >
                🔮 Know your correct gemstone now @ Rs.111/- Only
              </button>
            </div>
          </div>
        </section>
      </div>

      <div className="fb-jyotirvani">
        <div className="container">
          <section className="fb-hero">
            <h1 className="fb-title-heading">JyotirVani.com</h1>
            <p className="fb-text-paragraph">
              हम समझते हैं आपकी पीड़ा व आपके प्रश्नों को... और देते हैं आपको सभी
              प्रश्नों के सही और सरल समाधान।
            </p>
            <p className="fb-subtitle text-paragraph">
              JyotirVani केवल एक ज्योतिष सेवा नहीं — यह एक आध्यात्मिक संवाद है,
              आपके और ब्रह्मांड के बीच।
            </p>
          </section>

          <section className="fb-plans">
            <h2 className="fb-section-title">🔖 प्लान चुनें</h2>

            <div className="fb-plan-list">
              {plans.map((plan, index) => (
                <label className="fb-plan" key={index}>
                  <input
                    type="radio"
                    name="plan"
                    checked={selectedPlan?.label === plan.label}
                    onChange={() => setSelectedPlan(plan)}
                  />

                  <div>
                    <h3 className="fb-plan-heading">
                      {plan.label} - <span>{plan.value}</span>
                    </h3>

                    <p>
                      <strong>{plan.name}</strong>
                    </p>

                    <ul className="fb-text-list">
                      {plan.features.map((feature, i) => (
                        <li key={i}>{feature}</li>
                      ))}
                    </ul>

                    {selectedPlan?.label === plan.label && (
                      <button
                        type="button"
                        className="fb-btn booking"
                        onClick={() => {
                          setSelectedPlan(plan);
                          setShowModal(true);
                        }}
                      >
                        📞 Book Now ({plan.label})
                      </button>
                    )}
                  </div>
                </label>
              ))}

              {showModal && (
                <div className="FB-qr-modal-overlay">
                  <div className="FB-qr-modal-content">
                    <form className="payment-form" onSubmit={handleEmailAndPay}>
                      <h3>Enter Your Details</h3>

                      <div className="input-group">
                        <input
                          type="text"
                          name="name"
                          placeholder="Name"
                          value={form.name}
                          onChange={handleFormChange}
                          required
                        />

                        <input
                          type="tel"
                          name="phone"
                          placeholder="Phone"
                          value={form.phone}
                          onChange={handleFormChange}
                          required
                        />
                      </div>

                      <div className="input-group">
                        <input
                          type="email"
                          name="email"
                          placeholder="Email"
                          value={form.email}
                          onChange={handleFormChange}
                          required
                        />

                        <input
                          type="date"
                          name="dob"
                          value={form.dob}
                          onChange={handleFormChange}
                          required
                        />
                      </div>

                      <div className="input-group">
                        <input
                          type="time"
                          name="birthTime"
                          value={form.birthTime}
                          onChange={handleFormChange}
                          required
                        />

                        <input
                          type="text"
                          name="birthCity"
                          placeholder="Place of birth"
                          value={form.birthCity}
                          onChange={handleFormChange}
                          required
                        />
                      </div>

                      {Object.values(errors).map(
                        (error, index) =>
                          error && (
                            <p className="error-text" key={index}>
                              {error}
                            </p>
                          ),
                      )}

                      <div className="payment-buttons">
                        <button
                          type="submit"
                          className="ra-plan-contact-btn"
                          disabled={isSubmitting}
                        >
                          {isSubmitting
                            ? "Processing..."
                            : `Pay ₹${getPlanAmount(selectedPlan) || 111}`}
                        </button>

                        <button
                          type="button"
                          className="ra-plan-close-btn"
                          onClick={handleClose}
                          disabled={isSubmitting}
                        >
                          Cancel
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </section>

          <section className="fb-for-whom">
            <h2 className="fb-section-title">यह सेवा है उन लोगों के लिए —</h2>
            <ul className="fb-text-list">
              <li>जो जीवन की सही दिशा जानना चाहते हैं</li>
              <li>जो दुख का कारण समझना चाहते हैं</li>
              <li>जो ग्रहों की चाल में अपनी राह तलाशना चाहते हैं</li>
            </ul>
          </section>

          <section className="fb-services">
            <h2 className="fb-section-title">हमारी सेवा में क्या मिलेगा?</h2>

            {fbServices.map((service, index) => (
              <div className="fb-service-item" key={index}>
                <h3 className="fb-plan-heading">{service.title}</h3>
                <ul className="fb-text-list">
                  {service.features.map((feature, i) => (
                    <li key={i}>{feature}</li>
                  ))}
                </ul>
              </div>
            ))}
          </section>

          <footer className="fb-footer">
            <p>🌟 JyotirVani.com – शास्त्र विज्ञान से मानसिक शांति और सफलता।</p>
            <p>5000+ संतुष्ट साधक | 15+ वर्षों का अनुभव | शुद्ध वैदिक पद्धति</p>
          </footer>
        </div>
      </div>

      <FBSlider />

      <div
        style={{
          background: `
            radial-gradient(circle at top left, rgba(255, 181, 86, 0.18), transparent 30%),
            radial-gradient(circle at bottom right, rgba(253, 80, 137, 0.14), transparent 35%),
            linear-gradient(180deg, #fffaf2 0%, #fff 100%)
          `,
          padding: "50px 20px",
        }}
      >
        <Testimonial />
      </div>

      <div className="ra-indcon-main-accodiam">
        <div className="container">
          <h2>Why You Should Choose JyotirVani?</h2>

          <div className="ra-indcon-accordions">
            {accordionItems.map((item) => (
              <div className="ra-indcon-accordion" key={item.id}>
                <input type="checkbox" id={item.id} />

                <label
                  htmlFor={item.id}
                  className="ra-indcon-accordion__header"
                >
                  {item.icon && (
                    <img
                      src={item.icon}
                      alt="faq-icon"
                      className="ra-indcon-accordion__icon"
                      style={{ width: "100%", marginBottom: "8px" }}
                    />
                  )}

                  <span className="ra-indcon-accordion__header-text">
                    {item.title}
                  </span>
                </label>

                <div className="ra-indcon-accordion__content">
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FbBooknow;
